import { RecordingInfoAPI } from "./recinfo";

export class RecordingInfoLPRAPI extends RecordingInfoAPI {
  lpr_prj_list(
    project_id,
    callback,
    refresh_interval = global.default_refresh_interval
  ) {
    this.prj_list_base(project_id, callback, "/lpr", refresh_interval);
  }

  // LPR recording info
  list(
    project_id,
    zone_id,
    callback,
    refresh_interval = global.default_refresh_interval
  ) {
    this.list_base(project_id, zone_id, callback, "/lpr", refresh_interval);
  }

  fetch(
    project_id,
    zone_id,
    recording_info_id,
    callback,
    refresh_interval = global.default_refresh_interval
  ) {
    this.fetch_base(
      project_id,
      zone_id,
      recording_info_id,
      callback,
      "/lpr",
      refresh_interval
    );
  }

  update(project_id, zone_id, recording_info_id, changes, callback) {
    this.update_base(
      project_id,
      zone_id,
      recording_info_id,
      changes,
      callback,
      "/lpr"
    );
  }

  create(project_id, zone_id, rec_info, callback) {
    this.create_base(project_id, zone_id, rec_info, callback, "/lpr");
  }
}
